import { RevenueBreakdownChart } from "./RevenueBreakdownChart";

export function RevenueByProviderChart() {
  return (
    <RevenueBreakdownChart
      title="Revenue by provider"
      description="Contribution of each provider to captured revenue."
      chartType="REVENUE_BY_PROVIDER"
    />
  );
}

export function RevenueByMethodChart() {
  return (
    <RevenueBreakdownChart
      title="Revenue by method"
      description="Contribution of each payment method to captured revenue."
      chartType="REVENUE_BY_METHOD"
    />
  );
}
